export const LOADING = 'LOADING'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const REQUEST_USER = 'REQUEST_USER'
export const RECEIVE_USER = 'RECEIVE_USER'
export const REQUESTED_USER = 'REQUESTED_USER'

export const PREVIOUS_ROUTE = 'PREVIOUS_ROUTE'

export const WHITE_LABEL = 'WHITE_LABEL'
